import { InvoiceStatus } from '../../../domain/types';

export const markPaidInvoiceActionLabels: { [key in InvoiceStatus.PAID | InvoiceStatus.COLLECTED]: {
  action: {
    label: string,
    ariaLabel: string,
  },
  modal: {
    title: string,
    ariaLabel: string,
    confirmLabel: string,
    confirmAriaLabel: string,
  }
} } = {
  [InvoiceStatus.PAID]: {
    action: {
      label: 'Registra pagamento',
      ariaLabel: 'Azione per registrare il pagamento',
    },
    modal: {
      title: 'Registra il pagamento',
      ariaLabel: 'Modale per registrare il pagamento',
      confirmLabel: 'Registra pagamento',
      confirmAriaLabel: 'Azione per confermare la registrazione del pagamento',
    },
  },
  [InvoiceStatus.COLLECTED]: {
    action: {
      label: 'Incassa il pagamento',
      ariaLabel: 'Azione per incassare il pagamento',
    },
    modal: {
      title: 'Incassa il pagamento',
      ariaLabel: 'Modale per incassare il pagamento',
      confirmLabel: 'Incassa il pagamento',
      confirmAriaLabel: 'Azione per confermare l\'incasso del pagamento',
    },
  },
};
